module.exports = __webpack_public_path__ + "img/arbol.2ca54dc0.png";